import React from "react";
import { Modal } from "reactstrap";
import {ModalBody} from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../../../DiscussionNotes/DiscussionNotes.module.scss";
import Loader from "components/Loader";

const ConfirmModal = ({ t, isConfirmOpen, closeConfirmModal, handleSend, updateLoading }) => {
    return (
        <Modal
            isOpen={isConfirmOpen}
            toggle={closeConfirmModal}
            className="modal-dialog-centered modal-lg"
            modalClassName="custom-modal"
        >
            {updateLoading && <Loader />}
            <span className="close-btn" onClick={closeConfirmModal}>
                <img src={crossIcon} alt="close" />
            </span>
            <ModalBody>
                <div className={styles.delete_modal_container}>
                    <Text size="25px" weight="500" color="#111B45">
                        {t('employmentProof.sendTitle')}
                    </Text>
                    <Text size="16px" weight="300" color="#535B5F">
                        {t("employmentProof.sendConfirmMsg")}
                    </Text>

                    <div className={styles.btn_container + " " + "btn-box d-md-flex"}>
                        <button
                            className={
                                styles.green_btn + " " + "button button-round button-shadow"
                            }
                            title="save"
                            onClick={handleSend}
                        >
                            {t("employmentProof.send")}
                        </button>
                        <button
                            className={
                                styles.white_btn + " button button-round button-border btn-mobile-link button-dark"
                            }
                            title="cancel"
                            onClick={closeConfirmModal}
                        >
                            {t("employmentProof.form.cancel")}
                        </button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};
export default ConfirmModal
